import { isOAuthCallbackRoute } from 'helpers/authCallback';

const GTM_SCRIPT_ELEMENT_ID = 'google-tag-manager-script';

declare global {
  interface Window {
    dataLayer?: Array<Record<string, unknown>>;
  }
}

export const bootstrapGoogleTagManager = (
  containerId: string | undefined
): void => {
  if (
    !containerId ||
    typeof window === 'undefined' ||
    typeof document === 'undefined' ||
    document.getElementById(GTM_SCRIPT_ELEMENT_ID)
  ) {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });

  const script = document.createElement('script');
  script.id = GTM_SCRIPT_ELEMENT_ID;
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(
    containerId
  )}`;
  document.head.appendChild(script);
};

// Skip GTM on the /oauth/* redirect page - no engagement to track on a
// transient "please wait" screen the user sits on for a few seconds. Loads
// normally on every other route, including /onboarding/*.
if (!isOAuthCallbackRoute()) {
  bootstrapGoogleTagManager(import.meta.env.VITE_GTM_CONTAINER_ID);
}
